import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const giftWatches = [
    {
        id: 1,
        name: 'Timex Legacy Celestial',
        price: '₹11,495.00',
        image: 'https://images.unsplash.com/photo-1524592094714-0f0654e20314?q=80&w=1999&auto=format&fit=crop',
        tag: 'New'
    },
    {
        id: 2,
        name: 'Marlin Automatic',
        price: '₹16,495.00',
        image: 'https://images.unsplash.com/photo-1522312346375-d1a52e2b99b3?q=80&w=1988&auto=format&fit=crop',
        tag: 'Best Seller'
    },
    {
        id: 3,
        name: 'Q Timex Chronograph',
        price: '₹13,995.00',
        image: 'https://sc04.alicdn.com/kf/H1f8c007a90804ebdaf4541cfe60c26faX.jpg',
        tag: 'Trending'
    }
];

const HolidaySection = () => {
    return (
        <section className="bg-[#0B2447] text-white overflow-hidden relative">
            <div className="container mx-auto flex flex-col md:flex-row h-auto md:h-[600px]">

                {/* Left Content */}
                <div className="w-full md:w-1/2 p-8 md:p-16 flex flex-col justify-center relative z-10">
                    {/* Decorative Moon/Art */}
                    <div className="absolute top-0 left-0 w-64 h-64 bg-[#F2EFE5] rounded-full blur-3xl opacity-10 -translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>

                    <h3 className="text-lg md:text-xl mb-4 font-medium tracking-wide">This Holiday, Make Time Yours</h3>
                    <h2 className="text-4xl md:text-6xl font-serif font-bold mb-8 leading-tight">
                        Time is a Gift <span className="inline-block animate-spin-slow">❄️</span>
                    </h2>

                    <button className="bg-white text-[#0B2447] px-8 py-3 rounded-md font-semibold flex items-center gap-2 w-fit hover:bg-gray-100 transition-colors">
                        Explore Gifts <ArrowRight className="w-4 h-4" />
                    </button>

                    {/* Decorative Reindeer/Sleigh (CSS/SVG placeholder) */}
                    <div className="mt-12 opacity-80">
                        {/* Placeholder for the artistic graphic in the user image */}
                        <div className="w-full h-32 bg-gradient-to-r from-transparent via-white/5 to-transparent rounded-lg backdrop-blur-sm border border-white/10 flex items-center justify-center">
                            <span className="text-sm italic">Holiday Collection 2024</span>
                        </div>
                    </div>
                </div>

                {/* Right Slider */}
                <div className="w-full md:w-1/2 bg-[#F5F5F5] text-luxury-black p-8 md:p-16 flex items-center">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={30}
                        slidesPerView={1}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                        className="w-full max-w-md"
                    >
                        {giftWatches.map((watch) => (
                            <SwiperSlide key={watch.id}>
                                <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                                    <div className="relative aspect-square mb-6 overflow-hidden rounded-lg bg-gray-50">
                                        <span className="absolute top-2 right-2 bg-white px-2 py-1 text-xs font-bold uppercase tracking-wider border border-gray-100 rounded-sm">
                                            {watch.tag}
                                        </span>
                                        <img
                                            src={watch.image}
                                            alt={watch.name}
                                            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                                        />
                                    </div>
                                    <h3 className="text-lg font-bold font-serif mb-1">{watch.name}</h3>
                                    <p className="text-gray-500 text-sm mb-3">Stainless Steel • 3 Colors</p>
                                    <p className="text-xl font-semibold">{watch.price}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default HolidaySection;
